import { mutateApi } from "src/utils/api/ApiMethods"

export const connectWithMarina = ({ marinaId }) => {
  return mutateApi({
    url: `/marina_invites/${marinaId}/connect_with_marina`,
    method: "POST",
  })
}
